import { render } from "./BankAccountItem.vue?vue&type=template&id=6afe2fbf&scoped=true&ts=true"
import script from "./BankAccountItem.vue?vue&type=script&lang=ts"
export * from "./BankAccountItem.vue?vue&type=script&lang=ts"

import "./BankAccountItem.vue?vue&type=style&index=0&id=6afe2fbf&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6afe2fbf"]])

export default __exports__